/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DeleteLicenseResponse } from '../model';
// @ts-ignore
import { GetLicenseResponse } from '../model';
// @ts-ignore
import { GetLicensesResponse } from '../model';
// @ts-ignore
import { PostLicenseRequest } from '../model';
// @ts-ignore
import { PostLicenseResponse } from '../model';
// @ts-ignore
import { PutLicenseRequest } from '../model';
// @ts-ignore
import { PutLicenseResponse } from '../model';
/**
 * LicensesApi - axios parameter creator
 * @export
 */
export const LicensesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostLicenseRequest} postLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLicense: async (postLicenseRequest: PostLicenseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postLicenseRequest' is not null or undefined
            assertParamExists('createLicense', 'postLicenseRequest', postLicenseRequest)
            const localVarPath = `/api/licenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postLicenseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLicense: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLicense', 'id', id)
            const localVarPath = `/api/licenses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicense: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLicense', 'id', id)
            const localVarPath = `/api/licenses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [status] 
         * @param {string} [registrationDate] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicensesByKeyword: async (keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, status?: string, registrationDate?: string, expirationDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/licenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (registrationDate !== undefined) {
                localVarQueryParameter['registrationDate'] = registrationDate;
            }

            if (expirationDate !== undefined) {
                localVarQueryParameter['expirationDate'] = expirationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutLicenseRequest} putLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLicense: async (id: string, putLicenseRequest: PutLicenseRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLicense', 'id', id)
            // verify required parameter 'putLicenseRequest' is not null or undefined
            assertParamExists('updateLicense', 'putLicenseRequest', putLicenseRequest)
            const localVarPath = `/api/licenses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putLicenseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LicensesApi - functional programming interface
 * @export
 */
export const LicensesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LicensesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostLicenseRequest} postLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLicense(postLicenseRequest: PostLicenseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLicense(postLicenseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLicense(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteLicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLicense(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLicense(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLicense(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [status] 
         * @param {string} [registrationDate] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLicensesByKeyword(keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, status?: string, registrationDate?: string, expirationDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLicensesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLicensesByKeyword(keyword, limit, page, orderBy, orderDesc, status, registrationDate, expirationDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutLicenseRequest} putLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLicense(id: string, putLicenseRequest: PutLicenseRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutLicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLicense(id, putLicenseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LicensesApi - factory interface
 * @export
 */
export const LicensesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LicensesApiFp(configuration)
    return {
        /**
         * 
         * @param {PostLicenseRequest} postLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLicense(postLicenseRequest: PostLicenseRequest, options?: any): AxiosPromise<PostLicenseResponse> {
            return localVarFp.createLicense(postLicenseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLicense(id: string, options?: any): AxiosPromise<DeleteLicenseResponse> {
            return localVarFp.deleteLicense(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicense(id: string, options?: any): AxiosPromise<GetLicenseResponse> {
            return localVarFp.getLicense(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [status] 
         * @param {string} [registrationDate] 
         * @param {string} [expirationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLicensesByKeyword(keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, status?: string, registrationDate?: string, expirationDate?: string, options?: any): AxiosPromise<GetLicensesResponse> {
            return localVarFp.getLicensesByKeyword(keyword, limit, page, orderBy, orderDesc, status, registrationDate, expirationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutLicenseRequest} putLicenseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLicense(id: string, putLicenseRequest: PutLicenseRequest, options?: any): AxiosPromise<PutLicenseResponse> {
            return localVarFp.updateLicense(id, putLicenseRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createLicense operation in LicensesApi.
 * @export
 * @interface LicensesApiCreateLicenseRequest
 */
export interface LicensesApiCreateLicenseRequest {
    /**
     * 
     * @type {PostLicenseRequest}
     * @memberof LicensesApiCreateLicense
     */
    readonly postLicenseRequest: PostLicenseRequest
}

/**
 * Request parameters for deleteLicense operation in LicensesApi.
 * @export
 * @interface LicensesApiDeleteLicenseRequest
 */
export interface LicensesApiDeleteLicenseRequest {
    /**
     * 
     * @type {string}
     * @memberof LicensesApiDeleteLicense
     */
    readonly id: string
}

/**
 * Request parameters for getLicense operation in LicensesApi.
 * @export
 * @interface LicensesApiGetLicenseRequest
 */
export interface LicensesApiGetLicenseRequest {
    /**
     * 
     * @type {string}
     * @memberof LicensesApiGetLicense
     */
    readonly id: string
}

/**
 * Request parameters for getLicensesByKeyword operation in LicensesApi.
 * @export
 * @interface LicensesApiGetLicensesByKeywordRequest
 */
export interface LicensesApiGetLicensesByKeywordRequest {
    /**
     * 
     * @type {string}
     * @memberof LicensesApiGetLicensesByKeyword
     */
    readonly keyword?: string

    /**
     * 
     * @type {number}
     * @memberof LicensesApiGetLicensesByKeyword
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof LicensesApiGetLicensesByKeyword
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof LicensesApiGetLicensesByKeyword
     */
    readonly orderBy?: string

    /**
     * 
     * @type {string}
     * @memberof LicensesApiGetLicensesByKeyword
     */
    readonly orderDesc?: string

    /**
     * 
     * @type {string}
     * @memberof LicensesApiGetLicensesByKeyword
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof LicensesApiGetLicensesByKeyword
     */
    readonly registrationDate?: string

    /**
     * 
     * @type {string}
     * @memberof LicensesApiGetLicensesByKeyword
     */
    readonly expirationDate?: string
}

/**
 * Request parameters for updateLicense operation in LicensesApi.
 * @export
 * @interface LicensesApiUpdateLicenseRequest
 */
export interface LicensesApiUpdateLicenseRequest {
    /**
     * 
     * @type {string}
     * @memberof LicensesApiUpdateLicense
     */
    readonly id: string

    /**
     * 
     * @type {PutLicenseRequest}
     * @memberof LicensesApiUpdateLicense
     */
    readonly putLicenseRequest: PutLicenseRequest
}

/**
 * LicensesApi - object-oriented interface
 * @export
 * @class LicensesApi
 * @extends {BaseAPI}
 */
export class LicensesApi extends BaseAPI {
    /**
     * 
     * @param {LicensesApiCreateLicenseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicensesApi
     */
    public createLicense(requestParameters: LicensesApiCreateLicenseRequest, options?: AxiosRequestConfig) {
        return LicensesApiFp(this.configuration).createLicense(requestParameters.postLicenseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LicensesApiDeleteLicenseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicensesApi
     */
    public deleteLicense(requestParameters: LicensesApiDeleteLicenseRequest, options?: AxiosRequestConfig) {
        return LicensesApiFp(this.configuration).deleteLicense(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LicensesApiGetLicenseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicensesApi
     */
    public getLicense(requestParameters: LicensesApiGetLicenseRequest, options?: AxiosRequestConfig) {
        return LicensesApiFp(this.configuration).getLicense(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LicensesApiGetLicensesByKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicensesApi
     */
    public getLicensesByKeyword(requestParameters: LicensesApiGetLicensesByKeywordRequest = {}, options?: AxiosRequestConfig) {
        return LicensesApiFp(this.configuration).getLicensesByKeyword(requestParameters.keyword, requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, requestParameters.status, requestParameters.registrationDate, requestParameters.expirationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LicensesApiUpdateLicenseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicensesApi
     */
    public updateLicense(requestParameters: LicensesApiUpdateLicenseRequest, options?: AxiosRequestConfig) {
        return LicensesApiFp(this.configuration).updateLicense(requestParameters.id, requestParameters.putLicenseRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
